var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColouredStarredBackground3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 647,
    viewBox: "0 0 392 647",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 647,
    width: 647,
    height: 392,
    transform: "rotate(-90 0 647)",
    fill: "url(#paint0_radial_6980_10580)",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.79 114.517C127.79 114.957 127.409 115.314 126.938 115.314C126.467 115.314 126.086 114.956 126.086 114.517C126.086 114.076 126.467 113.719 126.938 113.719C127.408 113.719 127.79 114.076 127.79 114.517Z",
    fill: "url(#paint1_linear_6980_10580)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.581 241.669C349.581 242.109 349.2 242.466 348.729 242.466C348.258 242.466 347.877 242.109 347.877 241.669C347.877 241.228 348.258 240.871 348.729 240.871C349.2 240.871 349.581 241.228 349.581 241.669Z",
    fill: "url(#paint2_linear_6980_10580)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04383 262.717C5.04383 263.158 4.66265 263.514 4.19184 263.514C3.72102 263.514 3.33984 263.157 3.33984 262.717C3.33984 262.276 3.72102 261.919 4.19184 261.919C4.66265 261.919 5.04383 262.276 5.04383 262.717Z",
    fill: "url(#paint3_linear_6980_10580)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.691 316.679C372.691 317.119 372.31 317.476 371.839 317.476C371.368 317.476 370.987 317.119 370.987 316.679C370.987 316.239 371.368 315.881 371.839 315.881C372.31 315.881 372.691 316.238 372.691 316.679Z",
    fill: "url(#paint4_linear_6980_10580)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M345.826 331.403C345.826 331.844 345.445 332.201 344.974 332.201C344.503 332.201 344.122 331.843 344.122 331.403C344.122 330.963 344.503 330.606 344.974 330.606C345.445 330.606 345.826 330.963 345.826 331.403Z",
    fill: "url(#paint5_linear_6980_10580)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M372.293 386.254C372.293 386.695 371.912 387.052 371.441 387.052C370.97 387.052 370.589 386.694 370.589 386.254C370.589 385.815 370.97 385.457 371.441 385.457C371.912 385.457 372.293 385.814 372.293 386.254Z",
    fill: "url(#paint6_linear_6980_10580)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9618 356.318C70.9618 356.759 70.5806 357.116 70.1098 357.116C69.639 357.116 69.2578 356.758 69.2578 356.318C69.2578 355.878 69.639 355.521 70.1098 355.521C70.5797 355.521 70.9618 355.878 70.9618 356.318Z",
    fill: "url(#paint7_linear_6980_10580)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.009 369.445C101.009 369.886 100.627 370.243 100.157 370.243C99.6859 370.243 99.3047 369.885 99.3047 369.445C99.3047 369.005 99.6859 368.648 100.157 368.648C100.627 368.648 101.009 369.005 101.009 369.445Z",
    fill: "url(#paint8_linear_6980_10580)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.04 338.363C135.04 338.804 134.659 339.16 134.188 339.16C133.717 339.16 133.336 338.804 133.336 338.363C133.336 337.922 133.717 337.565 134.188 337.565C134.659 337.565 135.04 337.923 135.04 338.363Z",
    fill: "url(#paint9_linear_6980_10580)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23914 141.528C8.23914 141.968 7.85797 142.325 7.38715 142.325C6.91633 142.325 6.53516 141.968 6.53516 141.528C6.53516 141.087 6.9172 140.73 7.38715 140.73C7.85797 140.73 8.23914 141.087 8.23914 141.528Z",
    fill: "url(#paint10_linear_6980_10580)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M290.338 127.192C290.338 127.633 289.956 127.99 289.486 127.99C289.016 127.99 288.634 127.633 288.634 127.192C288.634 126.752 289.015 126.395 289.486 126.395C289.957 126.395 290.338 126.753 290.338 127.192Z",
    fill: "url(#paint11_linear_6980_10580)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.842 146.761C385.842 147.202 385.461 147.559 384.99 147.559C384.519 147.559 384.138 147.201 384.138 146.761C384.138 146.32 384.519 145.964 384.99 145.964C385.461 145.964 385.842 146.32 385.842 146.761Z",
    fill: "url(#paint12_linear_6980_10580)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M176.272 69.3227C176.272 69.7634 175.89 70.1201 175.42 70.1201C174.95 70.1201 174.568 69.7634 174.568 69.3227C174.568 68.882 174.95 68.5253 175.42 68.5253C175.89 68.5253 176.272 68.882 176.272 69.3227Z",
    fill: "url(#paint13_linear_6980_10580)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2841 92.9553C35.2841 93.3959 34.902 93.7527 34.4321 93.7527C33.9613 93.7527 33.5801 93.3959 33.5801 92.9553C33.5801 92.5146 33.9613 92.1578 34.4321 92.1578C34.902 92.1578 35.2841 92.5146 35.2841 92.9553Z",
    fill: "url(#paint14_linear_6980_10580)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6923 109.345C54.6923 109.785 54.3102 110.142 53.8403 110.142C53.3695 110.142 52.9883 109.785 52.9883 109.345C52.9883 108.904 53.3695 108.547 53.8403 108.547C54.3102 108.547 54.6923 108.904 54.6923 109.345Z",
    fill: "url(#paint15_linear_6980_10580)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9501 135.885C32.9501 136.326 32.568 136.683 32.0981 136.683C31.6273 136.683 31.2461 136.326 31.2461 135.885C31.2461 135.445 31.6273 135.088 32.0981 135.088C32.568 135.088 32.9501 135.445 32.9501 135.885Z",
    fill: "url(#paint16_linear_6980_10580)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.893 34.1453C135.893 34.586 135.512 34.9427 135.041 34.9427C134.571 34.9427 134.189 34.586 134.189 34.1453C134.189 33.7047 134.571 33.3479 135.041 33.3479C135.512 33.3479 135.893 33.7047 135.893 34.1453Z",
    fill: "url(#paint17_linear_6980_10580)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.462 61.571C110.462 62.0116 110.081 62.3684 109.61 62.3684C109.139 62.3684 108.758 62.0116 108.758 61.571C108.758 61.1303 109.139 60.7736 109.61 60.7736C110.081 60.7736 110.462 61.1303 110.462 61.571Z",
    fill: "url(#paint18_linear_6980_10580)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.626 13.7974C107.626 14.2381 107.245 14.5948 106.774 14.5948C106.303 14.5948 105.922 14.2381 105.922 13.7974C105.922 13.3568 106.303 13 106.774 13C107.245 13 107.626 13.3568 107.626 13.7974Z",
    fill: "url(#paint19_linear_6980_10580)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.911 84.5744C265.911 85.0151 265.53 85.3718 265.059 85.3718C264.588 85.3718 264.207 85.0151 264.207 84.5744C264.207 84.1337 264.589 83.777 265.059 83.777C265.53 83.777 265.911 84.1337 265.911 84.5744Z",
    fill: "url(#paint20_linear_6980_10580)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M309.532 40.1207C309.532 40.5613 309.151 40.9181 308.68 40.9181C308.209 40.9181 307.828 40.5613 307.828 40.1207C307.828 39.68 308.209 39.3232 308.68 39.3232C309.151 39.3232 309.532 39.68 309.532 40.1207Z",
    fill: "url(#paint21_linear_6980_10580)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M326.922 16.4515C326.922 16.8921 326.541 17.2489 326.07 17.2489C325.599 17.2489 325.218 16.8921 325.218 16.4515C325.218 16.0108 325.599 15.6541 326.07 15.6541C326.541 15.6541 326.922 16.0108 326.922 16.4515Z",
    fill: "url(#paint22_linear_6980_10580)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M366.621 15.5668C366.621 16.0075 366.24 16.3643 365.769 16.3643C365.298 16.3643 364.917 16.0075 364.917 15.5668C364.917 15.1262 365.298 14.7694 365.769 14.7694C366.24 14.7694 366.621 15.1262 366.621 15.5668Z",
    fill: "url(#paint23_linear_6980_10580)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M256.974 20.8749C256.974 21.3156 256.592 21.6724 256.122 21.6724C255.651 21.6724 255.27 21.3156 255.27 20.8749C255.27 20.4343 255.651 20.0775 256.122 20.0775C256.592 20.0775 256.974 20.4343 256.974 20.8749Z",
    fill: "url(#paint24_linear_6980_10580)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M377.315 40.1205C377.315 40.5612 376.934 40.918 376.463 40.918C375.993 40.918 375.611 40.5612 375.611 40.1205C375.611 39.6799 375.993 39.3231 376.463 39.3231C376.933 39.3231 377.315 39.6799 377.315 40.1205Z",
    fill: "url(#paint25_linear_6980_10580)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M355.278 85.4578C355.278 85.8985 354.897 86.2552 354.426 86.2552C353.955 86.2552 353.574 85.8985 353.574 85.4578C353.574 85.0172 353.956 84.6604 354.426 84.6604C354.896 84.6604 355.278 85.0172 355.278 85.4578Z",
    fill: "url(#paint26_linear_6980_10580)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M385.842 97.2156C385.842 97.6563 385.461 98.0131 384.99 98.0131C384.519 98.0131 384.138 97.6563 384.138 97.2156C384.138 96.775 384.519 96.4182 384.99 96.4182C385.461 96.4182 385.842 96.7758 385.842 97.2156Z",
    fill: "url(#paint27_linear_6980_10580)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.487 119.418C205.487 119.858 205.105 120.215 204.635 120.215C204.164 120.215 203.783 119.858 203.783 119.418C203.783 118.977 204.164 118.62 204.635 118.62C205.106 118.62 205.487 118.978 205.487 119.418Z",
    fill: "url(#paint28_linear_6980_10580)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M391 203.789C391 204.23 390.619 204.587 390.148 204.587C389.677 204.587 389.296 204.23 389.296 203.789C389.296 203.349 389.677 202.992 390.148 202.992C390.619 202.992 391 203.349 391 203.789Z",
    fill: "url(#paint29_linear_6980_10580)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.474 185.058C108.474 185.499 108.092 185.855 107.622 185.855C107.151 185.855 106.77 185.499 106.77 185.058C106.77 184.617 107.151 184.26 107.622 184.26C108.091 184.26 108.474 184.618 108.474 185.058Z",
    fill: "url(#paint30_linear_6980_10580)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M384.138 262.717C384.138 263.158 383.756 263.514 383.286 263.514C382.815 263.514 382.434 263.158 382.434 262.717C382.434 262.276 382.815 261.919 383.286 261.919C383.756 261.919 384.138 262.276 384.138 262.717Z",
    fill: "url(#paint31_linear_6980_10580)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8427 287.169C34.8427 287.609 34.4615 287.966 33.9907 287.966C33.5198 287.966 33.1387 287.609 33.1387 287.169C33.1387 286.728 33.5198 286.371 33.9907 286.371C34.4615 286.371 34.8427 286.728 34.8427 287.169Z",
    fill: "url(#paint32_linear_6980_10580)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5282 307.517C57.5282 307.957 57.147 308.314 56.6762 308.314C56.2054 308.314 55.8242 307.957 55.8242 307.517C55.8242 307.076 56.2054 306.719 56.6762 306.719C57.147 306.719 57.5282 307.076 57.5282 307.517Z",
    fill: "url(#paint33_linear_6980_10580)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8427 361.483C34.8427 361.924 34.4615 362.28 33.9907 362.28C33.5198 362.28 33.1387 361.924 33.1387 361.483C33.1387 361.042 33.5198 360.686 33.9907 360.686C34.4615 360.686 34.8427 361.042 34.8427 361.483Z",
    fill: "url(#paint34_linear_6980_10580)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0907 325.454C9.0907 325.895 8.70952 326.251 8.23871 326.251C7.76789 326.251 7.38672 325.895 7.38672 325.454C7.38672 325.013 7.76789 324.656 8.23871 324.656C8.70952 324.656 9.0907 325.013 9.0907 325.454Z",
    fill: "url(#paint35_linear_6980_10580)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.993 176.388C56.993 176.777 56.6119 177.093 56.1411 177.093C55.6702 177.093 55.2891 176.778 55.2891 176.388C55.2891 176 55.6702 175.684 56.1411 175.684C56.6119 175.684 56.993 176 56.993 176.388Z",
    fill: "url(#paint36_linear_6980_10580)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M222.159 356.318C222.629 356.318 223.011 355.961 223.011 355.521C223.011 355.08 222.629 354.723 222.159 354.723C221.688 354.723 221.307 355.08 221.307 355.521C221.307 355.961 221.688 356.318 222.159 356.318Z",
    fill: "url(#paint37_linear_6980_10580)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M100.677 285.365C100.677 285.805 100.295 286.162 99.8246 286.162C99.3538 286.162 98.9727 285.805 98.9727 285.365C98.9727 284.924 99.3538 284.567 99.8246 284.567C100.295 284.567 100.677 284.925 100.677 285.365Z",
    fill: "url(#paint38_linear_6980_10580)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M258.106 49.4577C258.106 49.8984 257.725 50.2551 257.254 50.2551C256.784 50.2551 256.402 49.8984 256.402 49.4577C256.402 49.017 256.784 48.6603 257.254 48.6603C257.725 48.6603 258.106 49.017 258.106 49.4577Z",
    fill: "url(#paint39_linear_6980_10580)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.62 42.6852C28.62 43.1259 28.2388 43.4827 27.768 43.4827C27.2972 43.4827 26.916 43.1259 26.916 42.6852C26.916 42.2446 27.2972 41.8878 27.768 41.8878C28.2388 41.887 28.62 42.2446 28.62 42.6852Z",
    fill: "url(#paint40_linear_6980_10580)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6742 67.4365C86.0234 67.7167 85.7806 67.9431 85.4821 70.425C85.1827 67.9439 84.9408 67.7167 82.2891 67.4365C84.9399 67.1563 85.1827 66.9299 85.4821 64.448C85.7806 66.9299 86.0225 67.1571 88.6742 67.4365Z",
    fill: "url(#paint41_linear_6980_10580)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0316 20.412C45.3808 20.6922 45.138 20.9186 44.8395 23.4005C44.5401 20.9194 44.2982 20.6922 41.6465 20.412C44.2973 20.1318 44.5401 19.9053 44.8395 17.4235C45.138 19.9053 45.3799 20.1326 48.0316 20.412Z",
    fill: "url(#paint42_linear_6980_10580)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38516 204.617C4.73433 204.897 4.49152 205.124 4.19302 207.605C3.89364 205.124 3.65171 204.897 1 204.617C3.65171 204.337 3.89364 204.111 4.19302 201.629C4.49152 204.111 4.73345 204.338 7.38516 204.617Z",
    fill: "url(#paint43_linear_6980_10580)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M309.862 360.135C307.211 360.415 306.968 360.642 306.67 363.124C306.37 360.643 306.128 360.415 303.477 360.135C306.127 359.855 306.37 359.629 306.67 357.147C306.968 359.629 307.21 359.856 309.862 360.135Z",
    fill: "url(#paint44_linear_6980_10580)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M356.178 357.481C353.527 357.761 353.284 357.988 352.986 360.47C352.687 357.989 352.445 357.761 349.793 357.481C352.444 357.201 352.687 356.975 352.986 354.493C353.284 356.975 353.526 357.202 356.178 357.481Z",
    fill: "url(#paint45_linear_6980_10580)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M212.945 37.133C210.294 37.4132 210.051 37.6397 209.752 40.1215C209.452 37.6405 209.21 37.4132 206.559 37.133C209.209 36.8528 209.452 36.6264 209.752 34.1445C210.051 36.6264 210.293 36.8536 212.945 37.133Z",
    fill: "url(#paint46_linear_6980_10580)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M141.609 52.2611C138.958 52.5413 138.715 52.7677 138.416 55.2496C138.116 52.7685 137.874 52.5413 135.223 52.2611C137.873 51.9809 138.116 51.7544 138.416 49.2726C138.715 51.7544 138.957 51.9817 141.609 52.2611Z",
    fill: "url(#paint47_linear_6980_10580)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M315.066 78.3025C312.415 78.5818 312.172 78.8091 311.873 81.291C311.573 78.8091 311.331 78.5827 308.68 78.3025C311.331 78.0223 311.573 77.7958 311.873 75.314C312.172 77.7958 312.415 78.0223 315.066 78.3025Z",
    fill: "url(#paint48_linear_6980_10580)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M348.618 48.7223C345.968 49.0016 345.725 49.2289 345.425 51.7108C345.126 49.2289 344.884 49.0025 342.232 48.7223C344.883 48.4421 345.126 48.2156 345.425 45.7338C345.725 48.2156 345.968 48.4421 348.618 48.7223Z",
    fill: "url(#paint49_linear_6980_10580)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M305.989 217.714C303.337 217.993 303.095 218.22 302.796 220.702C302.496 218.22 302.254 217.994 299.603 217.714C302.253 217.434 302.496 217.207 302.796 214.725C303.095 217.207 303.337 217.434 305.989 217.714Z",
    fill: "url(#paint50_linear_6980_10580)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M316.977 268.854C314.325 269.134 314.083 269.361 313.784 271.842C313.485 269.361 313.243 269.134 310.592 268.854C313.243 268.574 313.485 268.347 313.784 265.865C314.083 268.347 314.326 268.574 316.977 268.854Z",
    fill: "url(#paint51_linear_6980_10580)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M207.825 326.696C205.175 326.975 204.932 327.202 204.632 329.683C204.333 327.202 204.091 326.975 201.439 326.696C204.09 326.416 204.333 326.189 204.632 323.707C204.932 326.189 205.174 326.416 207.825 326.696Z",
    fill: "url(#paint52_linear_6980_10580)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122.372 262.717C119.722 262.997 119.479 263.223 119.179 265.705C118.88 263.224 118.638 262.997 115.986 262.717C118.637 262.436 118.88 262.21 119.179 259.728C119.479 262.21 119.721 262.436 122.372 262.717Z",
    fill: "url(#paint53_linear_6980_10580)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M359.824 119.416C357.172 119.696 356.93 119.923 356.631 122.404C356.332 119.923 356.09 119.696 353.438 119.416C356.089 119.136 356.332 118.91 356.631 116.428C356.93 118.91 357.173 119.137 359.824 119.416Z",
    fill: "url(#paint54_linear_6980_10580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6980_10580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(700.074 843) rotate(180) scale(700.074 411.432)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13034,
    stopColor: "#7F5FD8",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416676,
    stopColor: "#692AFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870611,
    stopColor: "#181819",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6980_10580",
    x1: 126.996,
    y1: 113.586,
    x2: 126.848,
    y2: 116.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6980_10580",
    x1: 348.787,
    y1: 240.738,
    x2: 348.639,
    y2: 243.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6980_10580",
    x1: 4.2498,
    y1: 261.786,
    x2: 4.10176,
    y2: 264.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6980_10580",
    x1: 371.897,
    y1: 315.748,
    x2: 371.749,
    y2: 318.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6980_10580",
    x1: 345.032,
    y1: 330.473,
    x2: 344.884,
    y2: 333.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6980_10580",
    x1: 371.499,
    y1: 385.324,
    x2: 371.351,
    y2: 388.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6980_10580",
    x1: 70.1678,
    y1: 355.388,
    x2: 70.0197,
    y2: 358.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6980_10580",
    x1: 100.215,
    y1: 368.515,
    x2: 100.067,
    y2: 371.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6980_10580",
    x1: 134.246,
    y1: 337.432,
    x2: 134.098,
    y2: 340.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6980_10580",
    x1: 7.44511,
    y1: 140.597,
    x2: 7.29707,
    y2: 143.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6980_10580",
    x1: 289.544,
    y1: 126.262,
    x2: 289.396,
    y2: 128.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6980_10580",
    x1: 385.048,
    y1: 145.831,
    x2: 384.9,
    y2: 148.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6980_10580",
    x1: 175.478,
    y1: 68.3922,
    x2: 175.33,
    y2: 71.0808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6980_10580",
    x1: 34.49,
    y1: 92.0247,
    x2: 34.342,
    y2: 94.7133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6980_10580",
    x1: 53.8982,
    y1: 108.414,
    x2: 53.7502,
    y2: 111.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6980_10580",
    x1: 32.156,
    y1: 134.955,
    x2: 32.008,
    y2: 137.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6980_10580",
    x1: 135.099,
    y1: 33.2148,
    x2: 134.951,
    y2: 35.9034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6980_10580",
    x1: 109.668,
    y1: 60.6405,
    x2: 109.52,
    y2: 63.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6980_10580",
    x1: 106.832,
    y1: 12.8669,
    x2: 106.684,
    y2: 15.5555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6980_10580",
    x1: 265.117,
    y1: 83.6439,
    x2: 264.969,
    y2: 86.3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6980_10580",
    x1: 308.738,
    y1: 39.1901,
    x2: 308.59,
    y2: 41.8787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6980_10580",
    x1: 326.128,
    y1: 15.521,
    x2: 325.98,
    y2: 18.2096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6980_10580",
    x1: 365.827,
    y1: 14.6363,
    x2: 365.679,
    y2: 17.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6980_10580",
    x1: 256.179,
    y1: 19.9444,
    x2: 256.031,
    y2: 22.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6980_10580",
    x1: 376.521,
    y1: 39.19,
    x2: 376.373,
    y2: 41.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6980_10580",
    x1: 354.484,
    y1: 84.5273,
    x2: 354.336,
    y2: 87.2159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6980_10580",
    x1: 385.048,
    y1: 96.2851,
    x2: 384.9,
    y2: 98.9737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6980_10580",
    x1: 204.693,
    y1: 118.487,
    x2: 204.545,
    y2: 121.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6980_10580",
    x1: 390.206,
    y1: 202.859,
    x2: 390.058,
    y2: 205.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6980_10580",
    x1: 107.679,
    y1: 184.127,
    x2: 107.531,
    y2: 186.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6980_10580",
    x1: 383.344,
    y1: 261.786,
    x2: 383.195,
    y2: 264.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6980_10580",
    x1: 34.0486,
    y1: 286.238,
    x2: 33.9006,
    y2: 288.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6980_10580",
    x1: 56.7342,
    y1: 306.586,
    x2: 56.5861,
    y2: 309.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6980_10580",
    x1: 34.0486,
    y1: 360.552,
    x2: 33.9006,
    y2: 363.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6980_10580",
    x1: 8.29667,
    y1: 324.523,
    x2: 8.14864,
    y2: 327.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6980_10580",
    x1: 56.199,
    y1: 175.566,
    x2: 56.0834,
    y2: 177.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6980_10580",
    x1: 222.217,
    y1: 354.59,
    x2: 222.069,
    y2: 357.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6980_10580",
    x1: 99.8826,
    y1: 284.434,
    x2: 99.7346,
    y2: 287.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6980_10580",
    x1: 257.312,
    y1: 48.5272,
    x2: 257.164,
    y2: 51.2158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6980_10580",
    x1: 27.826,
    y1: 41.7547,
    x2: 27.6779,
    y2: 44.4433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6980_10580",
    x1: 85.6988,
    y1: 63.9492,
    x2: 85.144,
    y2: 74.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6980_10580",
    x1: 45.0563,
    y1: 16.9247,
    x2: 44.5014,
    y2: 27.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6980_10580",
    x1: 4.40977,
    y1: 201.13,
    x2: 3.85505,
    y2: 211.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6980_10580",
    x1: 306.886,
    y1: 356.648,
    x2: 306.331,
    y2: 366.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6980_10580",
    x1: 353.203,
    y1: 353.994,
    x2: 352.648,
    y2: 364.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6980_10580",
    x1: 209.969,
    y1: 33.6457,
    x2: 209.414,
    y2: 43.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6980_10580",
    x1: 138.633,
    y1: 48.7738,
    x2: 138.078,
    y2: 58.8499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6980_10580",
    x1: 312.09,
    y1: 74.8152,
    x2: 311.535,
    y2: 84.8912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6980_10580",
    x1: 345.643,
    y1: 45.235,
    x2: 345.088,
    y2: 55.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6980_10580",
    x1: 303.013,
    y1: 214.226,
    x2: 302.458,
    y2: 224.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6980_10580",
    x1: 314.002,
    y1: 265.367,
    x2: 313.447,
    y2: 275.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6980_10580",
    x1: 204.85,
    y1: 323.209,
    x2: 204.295,
    y2: 333.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6980_10580",
    x1: 119.397,
    y1: 259.229,
    x2: 118.842,
    y2: 269.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6980_10580",
    x1: 356.848,
    y1: 115.929,
    x2: 356.294,
    y2: 126.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColouredStarredBackground3);
export default __webpack_public_path__ + "static/media/colouredStarredBackground3.03b392ac7923a7bea3eac9270686cacb.svg";
export { ForwardRef as ReactComponent };